export default __webpack_public_path__ + "static/media/pix.9642df8d.png";